<!-- PAGE TITLE
        ================================================== -->
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>Red Monk Wellness – Expert Profiles </h1>
                        <p>Meet the minds redefining personalized IV Therapy and performance wellness in India.
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>


<!-- Ashim Matthan Profile
        ================================================== -->

<section class="bg-light-color">
    <div class="container">

        <div class="row">
            <div class="col-lg-3 wow fadeInUp" data-wow-delay="200ms">
                <div class="card card-style-07 border-0 bg-transparent">
                    <div class="image ">
                        <a href="#"><img src="/assets/images/businessman.png"
                                alt="Deepak Kumar Das Timeless Monk" /></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-9 ps-lg-5 mt-5 mt-lg-0 wow fadeInUp" data-wow-delay="400ms">
                <div class="section-title left mb-3">
                    <!-- <span class="sm-title">RhinoMight </span> -->
                    <h2 class="display-16 lh-1 mb-2">Deepak Kumar Das</h2>
                    <p class="para">A Beacon of Positivity and Wellness at Timeless Monk </p>
                    <!-- <p class="para">Timeless Monk </p> -->
                    <div class="line"></div>
                </div>

                <div class="">
                    <ul class="list-unstyled list-style01 mb-0">
                        <li>Board-certified Clinical Cosmetologist</li>
                        <li>Postgraduate Diploma in Cosmetology (Zurich)</li>
                    </ul>


                </div>

                <div class="mt-1-9">
                    <h5 class="mb-2">Vision - </h5>
                    <p class="mb-2">Bringing advanced aesthetic science and wellness together to enhance confidence,
                        promote self-care, and deliver safe, results-driven transformations.</p>

                </div>

                <div class="mb-3 mt-3 pb-0 wow fadeInUp" data-wow-delay="200ms">
                    <h5 class="mb-2">Functional Wellness Strategist | Brain Performance Architect</h5>

                    <p class="mb-4">Hailing from a small town in Odisha, Deepak Kumar Das is a distinguished expert in
                        aesthetic medicine and wellness, recognized for his dedication to innovation, precision, and
                        transformative care.</p>

                    <p class="mb-4">He holds a Master’s and Fellowship in Aesthetic Medicine, is a Board Certified
                        Clinical Cosmetologist, and has completed a Post Graduate Diploma in Cosmetology from Zurich. He
                        also holds American Accreditation in Aesthetic Medicine, reflecting international standards of
                        excellence.</p>

                    <p class="mb-4">He is currently pursuing a PhD in Aesthetic Medicine, demonstrating his commitment
                        to research, advancement, and the future of aesthetic science.</p>

                </div>

            </div>




        </div>


    </div>
</section>